import React, { useState , useContext ,useEffect } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";
import { AuthContext } from "../user/AuthContext";
import axios from "axios";

const HASH_SECRET = '9e107d9d372bb6826bd81d3542a419d6';


const NavBar = () => {

  const [showMenu, setShowMenu] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); 
  const { auth, logout } = useContext(AuthContext);
  const [user, setUser] = useState(null);

  
  useEffect(() => {
    const userEmail = auth.email; 
    
    if (userEmail) {
        axios.get(`https://quickreact.onrender.com/getUser/${userEmail}`)
            .then(response => {
                console.log(response.data);
                setUser(response.data); 
            })
            .catch(error => console.log("User not found"));
    }
       }, [auth]);


       const handleLogout = () => {
        logout(); 
        localStorage.removeItem('hashedEmail'); 
        window.location.reload();
       }

       const scrollToPricing = () => {
        // Check current path
        if (window.location.pathname !== '/') {
            // Redirect to root path
            window.location.href = '/#nomore';
        } else {
            // Scroll to the 'paid' section
            const paidSection = document.getElementById('nomore');
            if (paidSection) {
                paidSection.scrollIntoView({ behavior: 'smooth' });
            } else {
                console.error("Element with id 'paid' not found.");
            }
        }
       };
        

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const toggleUserMenu = () => {
    setMenuOpen(!menuOpen); // Toggle menuOpen state
};


  return (
    <div className="nav-container">
      <div className="nav">
        <div className="logo">
          <Link to="/">
            Quick<span>React</span>
          </Link>
        </div>
        <div className="middle-links">
          <Link  to="#" onClick={scrollToPricing} >Pricing</Link>
          <Link to="mailto:quickreactchat@gmail.com">Contact</Link>
        </div>
        <div className="right-links">
          {user && user.username ? (
            <>
            <a onClick={toggleUserMenu}>welcome! {user.username} 👋</a>
            {menuOpen && (
             <div className="user-menu">
               <button onClick={handleLogout}>Logout</button>
             </div>
            )}
            </>
          ) : (
            <>
            <Link to="/login">Login</Link>
            <Link to="/signup">Sign up</Link>
            </>
            
          )}
          
        </div>
        <div className="menu" onClick={toggleMenu}>
          <svg
            width="50px"
            height="50px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 6H20M4 12H20M4 18H20"
              stroke="#61DBFB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </div>
        {showMenu && (
        <div className="dropdown-menu">
          {user && user.username && (<a>welcome! {user.username} 👋</a>)}
          <Link to="#" onClick={scrollToPricing}>Pricing</Link>
          <Link to="mailto:quickreactchat@gmail.com">Contact</Link>
          {user && user.username ? (
               <Link onClick={handleLogout}>Logout</Link>
          ) : (
            <>
          <Link to="/login">Login</Link>
          <Link to="/signup">Sign up</Link>
          </>
          
         )}
          
        </div>
      )}
      </div>
    </div>
  );
};

export default NavBar;
